import type { TFunction } from "i18next";

export type PeriodicityOption = { label: string; value: "Journalier" | "Mensuel" | "Annuel" };

/**
 * Build the periodicity dropdown options with translated labels but stable,
 * language-neutral values. The value strings are kept as the original French
 * keys so the existing getPeriodicity() value-mapping (and any stored data)
 * keeps working regardless of the active UI language.
 */
export const getPeriodicityOptions = (t: TFunction): PeriodicityOption[] => [
  { label: t("common.periodicityDaily", "Daily"), value: "Journalier" },
  { label: t("common.periodicityMonthly", "Monthly"), value: "Mensuel" },
  { label: t("common.periodicityYearly", "Yearly"), value: "Annuel" },
];

/** Accepts either a raw value string or a {label, value} option object. */
export const getPeriodicity = (
  period: string | { value?: string } | null | undefined
): number => {
  const key = typeof period === "string" ? period : period?.value ?? "";
  switch (key) {
    case "Journalier":
      return 1;
    case "Mensuel":
      return 2;
    case "Annuel":
      return 3;
    default:
      return 2;
  }
};

export const getPeriodicityByValue = (period: number): string => {
  switch (period) {
    case 1:
      return "Journalier";
    case 2:
      return "Mensuel";
    case 3:
      return "Annuel";
    default:
      return "";
  }
};

export const getPeriodicityLabelByValue = (
  period: string
): "Journalier" | "Mensuel" | "Annuel" | null => {
  switch (period) {
    case "daily":
      return "Journalier";
    case "monthly":
      return "Mensuel";
    case "annualy":
      return "Annuel";
    default:
      return null;
  }
};